/**
 * GA4 Client ID Capture for Shopify (Updated)
 * 1. Saves _ga cookie to Cart Attributes via AJAX (Background)
 * 2. Injects _ga cookie into 'Add to Cart' forms (Direct Checkout protection)
 */
(function() {
  function getClientId() {
    // Try to get from GA object
    if (typeof window.ga === 'function' && typeof window.ga.getAll === 'function') {
      var trackers = window.ga.getAll();
      if (trackers.length) return trackers[0].get('clientId');
    }
    // Fallback: Parse cookie
    var match = document.cookie.match(/(?:^|; )_ga=([^;]*)/);
    if (match && match[1]) {
      var parts = match[1].split('.');
      if (parts.length >= 4) return parts.slice(2).join('.');
    }
    return null;
  }

  function updateCartAttribute(clientId) {
    if (!clientId) return;
    
    // 1. Background AJAX Update (for browsing)
    if (sessionStorage.getItem('ga4_client_id_sent') !== clientId) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { '_ga_client_id': clientId } })
      }).then(function(res) {
        if (res.ok) sessionStorage.setItem('ga4_client_id_sent', clientId);
      }).catch(function(){});
    }

    // 2. Form Injection (for "Buy Now" / Direct Checkout)
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function(form) {
      // Check if input already exists
      if (form.querySelector('input[name="attributes[_ga_client_id]"]')) return;

      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[_ga_client_id]';
      input.value = clientId;
      form.appendChild(input);
    });
  }

  // Run immediately and retry a few times (in case forms load late)
  var attempts = 0;
  function run() {
    var cid = getClientId();
    if (cid) updateCartAttribute(cid);
    attempts++;
    if (attempts < 5) setTimeout(run, 1000);
  }
  
  // Start
  run();
})();